<template>
  <img class="bg" id="background-image" src="/site_assets/papers/paper.jpg" alt="">
    <div class="home">
      <div v-for="(image, index) in images" :key="index" class="images-background">
        <img
        v-if="index < visibleImages"
          :src="image.src"
          :style="{
            position: 'fixed',
            top: image.top + '%',
            left: image.left + '%',
            width: image.width + 'px',
            ...(image.style || {}),
          }"
          :class="image.class"
        />
      </div>

      <canvas id="canvas-drawing"></canvas> 
      <!-- <div id="threejs-canvas"></div> -->
      <div ref="p5container"></div>

    </div>
  </template>

  <script>
  //import p5 from 'p5';
  import { displayCollage } from '@/services/DisplayCollage';
  // import { initThree } from '@/services/HomePage3D';
  import { sketch } from '@/services/HomePageSketch';
  //import { spiral } from '@/services/DisplaySpiral';

  export default {
    name: 'HomePage',
    data() {
      return {
        images: [
          // { src: '/site_assets/HomePage/chambre_pastel.jpg' },
          { src: '/site_assets/HomePage/collage_pour_peinture.jpg' },
          { src: '/site_assets/HomePage/star5.png' },
          // { src: '/site_assets/HomePage/couverture_coquillages.jpg' },
          { src: '/site_assets/HomePage/coverartober_2024_20.jpg' },
          
          // { src: '/site_assets/HomePage/PICT0081.jpg' },
          // { src: '/site_assets/HomePage/bug.jpg' },
          { src: '/site_assets/HomePage/star4.png' },
          { src: '/site_assets/HomePage/page.jpg' },
          // { src: '/site_assets/HomePage/peinture_meduses.jpg' },
          { src: '/site_assets/HomePage/coverartober_2024_12.jpg' },
          { src: '/site_assets/HomePage/PICT0139.jpg' },
          // { src: '/site_assets/HomePage/triangle.png' },
          { src: '/site_assets/HomePage/wild_screen_1.jpg' },

          

          { src: '/site_assets/HomePage/coverartober_2025_04.jpg' },
          { src: '/site_assets/HomePage/coverartober_2025_10.jpg' },
          { src: '/site_assets/HomePage/coverartober_2025_09.png' },
          { src: '/site_assets/HomePage/coverartober_2025_08.jpg' },
          
          { src: '/site_assets/HomePage/calin.png'},

          { src: '/site_assets/HomePage/spiral.png'},

          { src: '/site_assets/HomePage/ascii.png'},

          { src: '/site_assets/HomePage/pilone.png' },

          { src: '/site_assets/HomePage/room5_1.png' },
          { src: '/site_assets/HomePage/star3.png' },
          { src: '/site_assets/HomePage/photo.png' },
          // { src: '/site_assets/HomePage/pietro.png' },
          { src: '/site_assets/HomePage/result.png' },
          { src: '/site_assets/HomePage/star2.png' },
          // { src: '/site_assets/HomePage/line1.jpg' },
          // { src: '/site_assets/HomePage/poisson.png' },
          { src: '/site_assets/HomePage/robe_bijoux.png' },
          // { src: '/site_assets/HomePage/result5.png' },
          { src: '/site_assets/HomePage/star1.png' },
          { src: '/site_assets/HomePage/chateau.gif' },
          { src: '/site_assets/HomePage/tulipes.gif' },
          { src: '/site_assets/HomePage/star.png' },
          { src: '/site_assets/HomePage/etoile.gif' }
        ],
        visibleImages: 0,
      };
    },
    mounted() {
      
      displayCollage(this.images);
      const totalDuration = 2000; 
      const intervalTime = totalDuration / this.images.length;

      const intervalId = setInterval(() => {
        if (this.visibleImages < this.images.length) {
          this.visibleImages += 1;
        } else {
          clearInterval(intervalId); 
        }
      }, intervalTime);

      // initThree('threejs-canvas');

      sketch();

      // spiral();

      //this.myP5 = new p5(spiral, this.$refs.p5container);
      
    },
    beforeUnmount() {
      if (this.myP5) {
        this.myP5.remove();
      }
    },
    methods: {

    }
  }
</script>

  
  <style scoped>

  .home {
    text-align: center;
    padding: 20px;
  }
  
  #background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover; 
    object-position: center; 
    z-index: -20;
    opacity: 30%;
  }

  #threejs-canvas {
    position: fixed;
    top: 0; 
    left: 0;
    z-index: -5;
    pointer-events: none;
}


  /* .collage-image {
    transition: all 1s ease-in-out;
  } */

  .images-background img{
    z-index: -10;
  }


  #canvas-drawing {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -15;
    pointer-events: none; 
  }

  /* pour le responsive */

  /* html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
} */

  </style>
  